import { render } from "./AddNewPlayer.vue?vue&type=template&id=55043dd4&scoped=true"
import script from "./AddNewPlayer.vue?vue&type=script&lang=js"
export * from "./AddNewPlayer.vue?vue&type=script&lang=js"

import "./AddNewPlayer.vue?vue&type=style&index=0&id=55043dd4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55043dd4"]])

export default __exports__